import React, { useState } from "react";
import { TextField, Button } from "@mui/material";
import { api } from "../api";
import "./auth.css";
import usePageTitle from "../hooks/usePageTitle";

const ForgotPassword = () => {
  usePageTitle("Forgot Password");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setSubmitting(true);
    try {
      const { data } = await api.post("/api/forgot-password", { email: String(email || "").trim() });
      setMessage(data?.message || "If that email exists, a reset link has been sent.");
    } catch (error) {
      const backendMessage = error?.response?.data?.message || "Unable to send reset link right now.";
      setMessage(backendMessage);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-box">
        <div className="auth-sidebar">
          <h3>Reset Your Password</h3>
          <p>Enter your email to receive a reset link.</p>
        </div>

        <div className="auth-form">
          <h2>Forgot Password</h2>
          <form onSubmit={handleSubmit}>
            <TextField
              label="Email"
              fullWidth
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
              required
              sx={{ mb: 2 }}
            />
            <Button type="submit" variant="contained" fullWidth className="auth-button" disabled={submitting}>
              {submitting ? "Sending..." : "Send Reset Link"}
            </Button>
          </form>
          <p className="message">{message}</p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
